module.exports = __webpack_public_path__ + "img/toolbox.6e365477.svg";